var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.98055 12.6626L8.3341 13.0148L8.68697 12.6619L13.8238 7.52503L14.2942 7.99876L8.33342 13.9596L5.70719 11.3333L6.17576 10.8648L7.98055 12.6626ZM2.16675 10.5C2.16675 6.17615 5.67622 2.66667 10.0001 2.66667C14.3239 2.66667 17.8334 6.17615 17.8334 10.5C17.8334 14.8239 14.3239 18.3333 10.0001 18.3333C5.67622 18.3333 2.16675 14.8239 2.16675 10.5ZM2.83341 10.5C2.83341 14.4511 6.04894 17.6667 10.0001 17.6667C13.9512 17.6667 17.1667 14.4511 17.1667 10.5C17.1667 6.54886 13.9512 3.33334 10.0001 3.33334C6.04894 3.33334 2.83341 6.54886 2.83341 10.5Z",
    fill: "#3CCC10",
    stroke: "#3CCC10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check_circle-green.9a269ca1d3c14801e85f8d7d43ce3011.svg";
export { ForwardRef as ReactComponent };